/* Dozzee characters (port of DozzeeMascot.dc.html).
   Markup comes from snippets/mascot.liquid:  <div class="dz-mascot" data-mascot="lilac" data-tap data-base="…/assets/" data-alts='{…}'>
   - auto-initialises every [data-mascot] on the page, including ones added later (MutationObserver)
   - window.DozzeeMascot.init(root)       → init mascots inside root (idempotent)
   - window.DozzeeMascot.set(el, who)     → switch an element to another character (rebuild + pop in)
   - window.DozzeeMascot.react(el)        → play the one-off tap reaction (also: el.dispatchEvent(new Event('dzpoke')))
   The body loops its action (run / jump / hug / love / walk); parts animate on their own. */
(function () {
  if (window.DozzeeMascot && window.DozzeeMascot._v) return;

  /* who → { ar: aspect ratio, act: body loop, parts: [index, left%, top%, width%, height%, kind] } */
  var D = {"red":{"ar":1.6216,"act":"run","parts":[[0,78.47,0.23,5,14.41,"burst"],[1,81.53,6.08,7.5,12.39,"burst"],[2,82.92,58.33,8.61,14.19,"burst"],[3,15.83,72.97,7.78,11.71,"tick"],[4,74.86,78.6,7.5,13.96,"tick"],[5,15.56,11.26,5,11.04,"burst"],[6,12.08,19.82,5.97,6.98,"burst"],[7,25.83,90.99,47.22,8.78,"shadow"]]},"yellow":{"ar":1.0198,"act":"jump","parts":[[0,0.28,1.7,30,29.32,"sun"],[1,31.81,9.49,8.61,10.2,"burst"],[2,0.28,31.73,10.56,10.91,"star"],[3,88.33,57.37,9.44,9.92,"star"],[4,84.17,72.1,14.58,20.82,"text"],[5,15.28,72.95,10,10.48,"burst"],[6,93.61,3.82,4.17,4.96,"burst"],[7,94.86,7.37,5,3.68,"burst"],[8,83.61,27.2,4.58,7.51,"burst"],[9,85.56,29.6,7.22,7.08,"burst"],[10,89.44,38.1,4.86,7.79,"burst"],[11,92.64,43.06,6.94,5.38,"burst"]]},"pink":{"ar":1.1726,"act":"hug","parts":[[0,86.25,12.21,8.75,11.73,"burst"],[1,6.39,21.82,8.06,8.63,"burst"],[2,90.83,49.19,9.03,9.77,"heart"],[3,75.97,0.16,11.25,12.05,"heart"],[4,9.44,1.14,21.11,21.99,"heart"],[5,33.19,7.17,6.81,7,"heart"]]},"lilac":{"ar":1.204,"act":"love","parts":[[0,14.86,5.18,18.06,19.9,"heart"],[1,83.06,41.64,8.47,10.37,"burst"],[2,81.25,56.19,10.14,11.87,"heart"],[3,91.11,1,3.33,6.02,"spark"],[4,93.75,4.68,4.58,4.68,"spark"],[5,35.28,11.71,8.75,10.03,"heart"],[6,14.03,24.92,5.14,7.36,"burst"],[7,11.11,30.6,6.39,3.85,"burst"]]},"green":{"ar":1.039,"act":"walk","parts":[[0,2.5,0.14,42.36,34.78,"bubble"],[1,90.83,9.38,5.14,7.07,"burst"],[2,67.64,16.74,5.56,4.62,"burst"],[3,5.42,30.16,4.31,7.22,"burst"],[4,87.64,34.63,10,11.54,"heart"],[5,0.14,35.06,6.39,5.48,"burst"],[6,70.14,6.78,4.86,8.23,"burst"],[7,74.31,11.54,15.56,17.32,"leaf"],[8,84.58,19.34,11.53,14.29,"leaf"],[9,10.69,32.61,7.64,10.53,"static"],[10,14.86,76.33,10.28,12.41,"tick"],[11,18.61,80.38,6.39,12.99,"tick"]]},"taupe":{"ar":1.6216,"act":"run","parts":[[0,78.47,0.23,5,14.41,"burst"],[1,81.53,6.08,7.5,12.39,"burst"],[2,82.92,58.33,8.61,14.19,"burst"],[3,15.83,72.97,7.78,11.71,"tick"],[4,74.86,78.6,7.5,13.96,"tick"],[5,15.56,11.26,5,11.04,"burst"],[6,12.08,19.82,5.97,6.98,"burst"],[7,25.83,90.99,47.22,8.78,"shadow"]]},"grey":{"ar":1.6216,"act":"run","parts":[[0,78.47,0.23,5,14.41,"burst"],[1,81.53,6.08,7.5,12.39,"burst"],[2,82.92,58.33,8.61,14.19,"burst"],[3,15.83,72.97,7.78,11.71,"tick"],[4,74.86,78.6,7.5,13.96,"tick"],[5,15.56,11.26,5,11.04,"burst"],[6,12.08,19.82,5.97,6.98,"burst"],[7,25.83,90.99,47.22,8.78,"shadow"]]}};

  function pick(w) { w = String(w || '').toLowerCase(); return D[w] ? w : 'pink'; }
  function $$(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
  function isReduce() {
    if (window.Dozzee && typeof window.Dozzee.reduce === 'boolean') return window.Dozzee.reduce;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function whenGsap(cb) {
    if (window.Dozzee && window.Dozzee.gsap) { window.Dozzee.gsap(function (gsap) { cb(gsap); }); return; }
    var n = 0;
    (function wait() { if (window.gsap) return cb(window.gsap); if (n++ < 150) setTimeout(wait, 80); })();
  }

  /* ---------- markup (mirrors snippets/mascot.liquid) ---------- */
  function partImg(base, w, p, withOx) {
    var cx = p[1] + p[3] / 2, cy = p[2] + p[4] / 2;
    var ox = (cx < 50 ? '100%' : '0%') + ' ' + (cy < 50 ? '100%' : '0%');
    return '<img data-part="' + p[5] + '"' + (withOx ? ' data-ox="' + ox + '"' : '') +
      ' src="' + base + 'crew-' + w + '-p' + p[0] + '.webp" alt="" draggable="false" decoding="async"' +
      ' style="left:' + p[1] + '%;top:' + p[2] + '%;width:' + p[3] + '%;height:' + p[4] + '%">';
  }
  function alts(el) {
    if (!el._dzAlts) { try { el._dzAlts = JSON.parse(el.getAttribute('data-alts') || '{}'); } catch (e) { el._dzAlts = {}; } }
    return el._dzAlts;
  }
  function build(el, w) {
    var d = D[w], base = el.getAttribute('data-base') || '', alt = alts(el)[w] || '';
    var under = '', attached = '', parts = '';
    d.parts.forEach(function (p) {
      if (p[5] === 'shadow') under += partImg(base, w, p, false);
      else if (p[5] === 'static') attached += partImg(base, w, p, false);
      else parts += partImg(base, w, p, true);
    });
    var tmp = document.createElement('span'); tmp.textContent = alt;
    el.setAttribute('data-mascot', w);
    el.style.setProperty('--ar', String(d.ar));
    el.innerHTML = under +
      '<div class="dz-mascot__body" data-body><img class="dz-mascot__base" src="' + base + 'crew-' + w + '-body.webp" alt="' +
      tmp.innerHTML.replace(/"/g, '&quot;') + '" draggable="false" decoding="async">' + attached + '</div>' + parts;
  }

  /* ---------- motion ---------- */
  function state(el) { return el._dzm || (el._dzm = { ctx: null, io: null, loops: [], bodyLoops: [], busy: false }); }

  function stop(el) {
    var st = el._dzm; if (!st) return;
    if (st.io) st.io.disconnect();
    if (st.ctx) st.ctx.revert();
    st.ctx = null; st.io = null; st.loops = []; st.bodyLoops = []; st.busy = false;
  }

  function start(el) {
    var gsap = window.gsap, st = state(el);
    if (!gsap || st.ctx || !el.isConnected) return;
    var reduce = isReduce();
    var body = el.querySelector('[data-body]'), P = function (k) { return $$(el, '[data-part="' + k + '"]'); };
    var R = gsap.utils.random, loops = [], bodyLoops = [];
    var L = function (t, b) { loops.push(t); if (b) bodyLoops.push(t); return t; };
    var act = D[pick(el.getAttribute('data-mascot'))].act;
    st.ctx = gsap.context(function () {
      gsap.set(body, { transformOrigin: '50% 90%' });
      if (reduce) return;
      if (act === 'run') {
        L(gsap.timeline({ repeat: -1 }).to(body, { yPercent: -5, duration: 0.17, ease: 'power2.out' }).to(body, { yPercent: 0, duration: 0.17, ease: 'power2.in' }).to(body, { scaleY: 0.95, scaleX: 1.03, duration: 0.07, yoyo: true, repeat: 1, ease: 'power1.out' }), 1);
        L(gsap.fromTo(body, { rotation: -2 }, { rotation: 2.5, duration: 0.48, ease: 'sine.inOut', yoyo: true, repeat: -1 }), 1);
        P('shadow').forEach(function (s) { L(gsap.timeline({ repeat: -1 }).to(s, { scaleX: 0.84, opacity: 0.65, duration: 0.17, ease: 'power2.out' }).to(s, { scaleX: 1, opacity: 1, duration: 0.17, ease: 'power2.in' }).to({}, { duration: 0.14 })); });
      } else if (act === 'jump') {
        L(gsap.timeline({ repeat: -1, repeatDelay: 0.9 }).to(body, { scaleY: 0.9, scaleX: 1.06, duration: 0.16, ease: 'power2.out' }).to(body, { yPercent: -12, scaleY: 1.05, scaleX: 0.97, duration: 0.3, ease: 'power2.out' }).to(body, { yPercent: 0, scaleY: 1, scaleX: 1, duration: 0.28, ease: 'power2.in' }).to(body, { scaleY: 0.93, scaleX: 1.05, duration: 0.08, ease: 'power1.out' }).to(body, { scaleY: 1, scaleX: 1, duration: 0.4, ease: 'elastic.out(1,0.5)' }), 1);
      } else if (act === 'hug') {
        L(gsap.timeline({ repeat: -1, repeatDelay: 0.55 }).to(body, { scale: 1.035, duration: 0.11, ease: 'power2.out' }).to(body, { scale: 1, duration: 0.13, ease: 'power2.in' }).to(body, { scale: 1.055, duration: 0.12, ease: 'power2.out' }).to(body, { scale: 1, duration: 0.3, ease: 'power2.inOut' }), 1);
        L(gsap.fromTo(body, { rotation: -1.5 }, { rotation: 1.5, duration: 1.6, ease: 'sine.inOut', yoyo: true, repeat: -1 }), 1);
      } else if (act === 'love') {
        L(gsap.fromTo(body, { rotation: -3 }, { rotation: 3, duration: 1.2, ease: 'sine.inOut', yoyo: true, repeat: -1 }), 1);
        L(gsap.to(body, { yPercent: -2.5, duration: 0.6, ease: 'sine.inOut', yoyo: true, repeat: -1 }), 1);
      } else {
        L(gsap.to(body, { yPercent: -3, duration: 0.42, ease: 'sine.inOut', yoyo: true, repeat: -1 }), 1);
        L(gsap.fromTo(body, { rotation: -1.5 }, { rotation: 1.5, duration: 0.84, ease: 'sine.inOut', yoyo: true, repeat: -1 }), 1);
      }
      P('heart').forEach(function (e, i) { L(gsap.to(e, { yPercent: -14, rotation: R(-9, 9), duration: R(1.3, 2), ease: 'sine.inOut', yoyo: true, repeat: -1, delay: i * 0.2 })); L(gsap.to(e, { scale: 1.12, duration: 0.5, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: i * 0.15 })); });
      P('burst').forEach(function (e, i) { L(gsap.fromTo(e, { scale: 0.72, opacity: 0.3 }, { scale: 1.1, opacity: 1, duration: 0.55, ease: 'power2.out', yoyo: true, repeat: -1, delay: (i % 4) * 0.12, transformOrigin: e.getAttribute('data-ox') || '50% 50%' })); });
      P('tick').forEach(function (e, i) { L(gsap.fromTo(e, { opacity: 0.15, xPercent: 12 }, { opacity: 1, xPercent: -12, duration: 0.2, ease: 'none', yoyo: true, repeat: -1, delay: i * 0.1 })); });
      P('star').concat(P('spark')).forEach(function (e, i) { L(gsap.to(e, { scale: 0.68, rotation: 28, duration: 0.7, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: i * 0.25 })); });
      P('sun').forEach(function (e) { L(gsap.fromTo(e, { rotation: -8 }, { rotation: 12, duration: 2.2, ease: 'sine.inOut', yoyo: true, repeat: -1 })); L(gsap.to(e, { yPercent: -6, duration: 1.6, ease: 'sine.inOut', yoyo: true, repeat: -1 })); });
      P('text').forEach(function (e) { L(gsap.to(e, { yPercent: -5, rotation: -2, duration: 1.3, ease: 'sine.inOut', yoyo: true, repeat: -1 })); });
      P('bubble').forEach(function (e) { L(gsap.timeline({ repeat: -1, repeatDelay: 1.6 }).to(e, { scale: 1.08, rotation: -3, duration: 0.18, ease: 'power2.out', transformOrigin: '15% 95%' }).to(e, { scale: 1, rotation: 0, duration: 0.7, ease: 'elastic.out(1,0.4)' })); });
      P('leaf').forEach(function (e, i) { L(gsap.fromTo(e, { rotation: -6 }, { rotation: 10, duration: 1.5 + i * 0.3, ease: 'sine.inOut', yoyo: true, repeat: -1, transformOrigin: '15% 90%' })); });
    }, el);
    st.loops = loops; st.bodyLoops = bodyLoops;
    if ('IntersectionObserver' in window) {
      st.io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          (st.loops || []).forEach(function (t) {
            if (e.isIntersecting) { if (!st.busy || st.bodyLoops.indexOf(t) < 0) t.resume(); } else t.pause();
          });
        });
      }, { rootMargin: '120px' });
      st.io.observe(el);
    }
  }

  function react(el) {
    var gsap = window.gsap, st = el && el._dzm;
    if (!gsap || !st || !st.ctx || st.busy) return;
    if (isReduce()) return;
    var body = el.querySelector('[data-body]'), P = function (k) { return $$(el, '[data-part="' + k + '"]'); };
    var act = D[pick(el.getAttribute('data-mascot'))].act;
    st.busy = true; st.bodyLoops.forEach(function (t) { t.pause(); });
    var done = function () { st.busy = false; st.bodyLoops.forEach(function (t) { t.resume(); }); };
    st.ctx.add(function () {
      var tl = gsap.timeline({ onComplete: done });
      if (act === 'run') tl.to(body, { yPercent: -10, duration: 0.11, ease: 'power1.out', yoyo: true, repeat: 7 }).to(body, { yPercent: 0, duration: 0.1 });
      else if (act === 'jump') tl.to(body, { scaleY: 0.86, scaleX: 1.08, duration: 0.14, ease: 'power2.out' }).to(body, { yPercent: -30, rotation: 360, scaleY: 1.04, scaleX: 0.98, duration: 0.55, ease: 'power2.out' }).to(body, { yPercent: 0, scaleY: 1, scaleX: 1, duration: 0.4, ease: 'bounce.out' }).set(body, { rotation: 0 });
      else if (act === 'hug' || act === 'love') tl.to(body, { scale: 1.12, duration: 0.16, ease: 'power2.out' }).to(body, { scale: 1, duration: 0.7, ease: 'elastic.out(1,0.35)' }).to(body, { rotation: 0, duration: 0.2 }, 0);
      else tl.to(body, { rotation: -10, yPercent: 0, duration: 0.28, ease: 'power2.out' }).to(body, { rotation: -10, duration: 0.6 }).to(body, { rotation: 0, duration: 0.5, ease: 'back.out(2.2)' });
      P('heart').forEach(function (e, i) { gsap.fromTo(e, { opacity: 1 }, { scale: 1.6, yPercent: -60, opacity: 0, duration: 0.7, delay: i * 0.06, ease: 'power2.out', onComplete: function () { gsap.fromTo(e, { scale: 0.4, yPercent: 0, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.5, ease: 'back.out(2)' }); } }); });
      P('burst').concat(P('star'), P('spark')).forEach(function (e) { gsap.fromTo(e, { scale: 1.5 }, { scale: 1, duration: 0.6, ease: 'elastic.out(1,0.4)' }); });
      P('bubble').forEach(function (e) { gsap.fromTo(e, { scale: 1.2 }, { scale: 1, duration: 0.8, ease: 'elastic.out(1,0.35)', transformOrigin: '15% 95%' }); });
    });
  }

  /* ---------- lifecycle ---------- */
  function setup(el) {
    if (el._dzmInit) return;
    el._dzmInit = true;
    state(el);
    if (!el._dzmL) {
      el._dzmL = true;
      el.addEventListener('click', function () { if (el.hasAttribute('data-tap')) react(el); });
      el.addEventListener('dzpoke', function () { react(el); });
    }
    whenGsap(function () { start(el); });
  }

  function mascotsIn(node) {
    if (!node || node.nodeType !== 1) return [];
    var list = node.matches && node.matches('[data-mascot]') ? [node] : [];
    return list.concat($$(node, '[data-mascot]'));
  }

  function init(root) { mascotsIn(root || document.documentElement).forEach(setup); }

  function set(el, w) {
    if (!el) return;
    w = pick(w);
    if (el.getAttribute('data-mascot') === w && el.querySelector('[data-body]')) return;
    stop(el);
    build(el, w);
    if (!el._dzmInit) { setup(el); return; }
    whenGsap(function (gsap) {
      start(el);
      var st = el._dzm;
      if (!isReduce() && st && st.ctx) st.ctx.add(function () {
        gsap.fromTo(el, { scale: 0.55, yPercent: 14, opacity: 0, rotation: -8 }, { scale: 1, yPercent: 0, opacity: 1, rotation: 0, duration: 0.7, ease: 'back.out(1.8)' });
      });
    });
  }

  window.DozzeeMascot = { _v: 1, D: D, init: init, set: set, react: react, stop: stop };

  function boot() {
    init(document.documentElement);
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          Array.prototype.forEach.call(m.addedNodes, function (n) { mascotsIn(n).forEach(setup); });
          Array.prototype.forEach.call(m.removedNodes, function (n) {
            mascotsIn(n).forEach(function (el) { if (!el.isConnected) { stop(el); el._dzmInit = false; el._dzm = null; } });
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
